import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-default-clem-loading',
  templateUrl: './default-clem-loading.component.html',
  styleUrls: ['./default-clem-loading.component.scss']
})
export class DefaultClemLoadingComponent implements OnInit {

  private _loadingText : string = "";
  get loadingText() : string {
    return this._loadingText;
  }

  @Input()
  set loadingText(loadingText : string) {
    if (loadingText !== null) {
      this._loadingText = loadingText;
    }
  }

  constructor() { }

  ngOnInit() {
  }

}
